import { render, staticRenderFns } from "./WorkOrderBin.vue?vue&type=template&id=67d3208e&scoped=true&"
import script from "./WorkOrderBin.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderBin.vue?vue&type=script&lang=ts&"
import style0 from "./WorkOrderBin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WorkOrderBin.vue?vue&type=style&index=1&id=67d3208e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3208e",
  null
  
)

component.options.__file = "WorkOrderBin.vue"
export default component.exports